import React from 'react';

import useClassy from '@core/hooks/useClassy';
import { ConnectSuperHubStoreToRouter, InitializeSuperHubVersions } from '@core/store';

import type { SuperHubProps } from '@routes/SuperHub';
import { SuperHubContextProvider } from '@routes/SuperHub/components/Context';
import classes from '@routes/SuperHub/index.module.scss';

/**
 * Renders read-only SuperHub UI for end users that should only be able to see
 * and read docs. This is the default view for logged out users.
 */
export default function ViewContainer({ children, versions }: SuperHubProps) {
  const bem = useClassy(classes, 'SuperHub');

  return (
    <SuperHubContextProvider>
      <InitializeSuperHubVersions initialVersions={versions}>
        <ConnectSuperHubStoreToRouter>
          <div className={bem()}>{children}</div>
        </ConnectSuperHubStoreToRouter>
      </InitializeSuperHubVersions>
    </SuperHubContextProvider>
  );
}
